// Written in this round about way for babel-transform-imports
import StaticRouter from 'react-router/es/StaticRouter';

export default StaticRouter;


//////////////////
// WEBPACK FOOTER
// ../~/react-router-dom/es/StaticRouter.js
// module id = 1114
// module chunks = 0